import React from "react";
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import "nepali-datepicker-reactjs/dist/index.css";
import { Form, DatePicker } from "rsuite";

const PersonalInformation = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group className="mb-0">
        <Form.ControlLabel>KYC No.</Form.ControlLabel>
        <Form.Control name="KYCNo." />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Branch</Form.ControlLabel>
        <Form.Control name="Branch" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Residence status</Form.ControlLabel>
        <Form.Control name="Residencestatus" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Nationality</Form.ControlLabel>
        <Form.Control name="Nationality" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Religion</Form.ControlLabel>
        <Form.Control name="Religion" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Salutation</Form.ControlLabel>
        <Form.Control name="Salutation" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>First Name</Form.ControlLabel>
        <Form.Control name="FirstName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Middle Name</Form.ControlLabel>
        <Form.Control name="MiddleName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Last Name</Form.ControlLabel>
        <Form.Control name="LastName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Full Name in Nepali</Form.ControlLabel>
        <Form.Control name="FullNameinNepali" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel className="nepali-datepicker-style">
          DOB in Nepali
        </Form.ControlLabel>

        <Form.Control
          name="DOBinNepali"
          accepter={Calendar}
          language="en"
          className="rs-input"
          dateformat="YYYY-MM-DD"
        />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>DOB</Form.ControlLabel>
        <Form.Control name="DOB" accepter={DatePicker} className="w-full" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Gender</Form.ControlLabel>
        <Form.Control name="Gender" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Place of Birth</Form.ControlLabel>
        <Form.Control name="PlaceofBirth" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Marital Status</Form.ControlLabel>
        <Form.Control name="MaritalStatus" />
      </Form.Group>
    </div>
  );
};

export default PersonalInformation;
